var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAidropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 15.9999C11.8686 16.0007 11.7381 15.9755 11.6163 15.9257C11.4944 15.8759 11.3836 15.8026 11.2902 15.7099L5.29019 9.70994C5.10188 9.52164 4.99609 9.26624 4.99609 8.99994C4.99609 8.73364 5.10188 8.47825 5.29019 8.28994C5.47849 8.10164 5.73388 7.99585 6.00019 7.99585C6.26649 7.99585 6.52188 8.10164 6.71019 8.28994L12.0002 13.5899L17.2902 8.29994C17.4815 8.13612 17.7276 8.05051 17.9792 8.06023C18.2309 8.06995 18.4697 8.17428 18.6477 8.35238C18.8258 8.53047 18.9302 8.76921 18.9399 9.02089C18.9496 9.27256 18.864 9.51864 18.7002 9.70994L12.7002 15.7099C12.5139 15.8947 12.2625 15.9988 12.0002 15.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidropdown);
export default __webpack_public_path__ + "static/media/Aidropdown.63e765aec7460ee0442d45cf94986c2e.svg";
export { ForwardRef as ReactComponent };